/* React Higher Order Component which fetches organization integration tag data for organization where id = props.orgId
    Child (WrappedComponent) will only render once assignmetn data is successfully fetched.
    child will receive props: {
        orgId:  PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        orgIntegrationTags: PropTypes.object
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const has = require('lodash/has');
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const OrganizationActions = require('../../actions/OrganizationActions');
const OrganizationStore = require('../../stores/OrganizationStore');
const ChannelStore = require('../../stores/channel_store_reflux');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    renderBeforeLodingTags: PropTypes.bool,
    forceRefresh: PropTypes.bool,
};

const defaultProps = {
    renderBeforeLodingTags: false,
    forceRefresh: false,
};

export default function withOrganizationIntegrationTags(WrappedComponent) {
    class WithOrganizationIntegrationTags extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                orgIntegrationTags: OrganizationStore.getState().orgIntegrationTags,
                getActionId: null,
                fatalError: null
            };

            this.getOrgIntegrationTags = this.getOrgIntegrationTags.bind(this);
            this.unsubscribes = [
                OrganizationStore.listen(this.onOrganizationStoreChange.bind(this)),
                ChannelStore.listen(this.onChannelStoreChange.bind(this))
            ];
        }

        UNSAFE_componentWillMount() {
            this.getOrgIntegrationTags(this.props.orgId, this.props.forceRefresh);
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            if (!nextProps.orgId) return;

            if (nextProps.orgId !== this.props.orgId) {
                this.getOrgIntegrationTags(nextProps.orgId, this.props.forceRefresh);
            }
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(unsubscribeCallback => unsubscribeCallback());
        }

        getOrgIntegrationTags(orgId, forceRefresh=false) {
            const channelStoreState = ChannelStore.getStateChannel(orgId);
            if (
                channelStoreState.initialized
                && FeatureUtil.hasIntegrationTags(channelStoreState.channel.channel_permissions)
                && PermissionsUtil.canViewIntegrationTags(channelStoreState.channel.user_permissions)
            ) {
                if (!forceRefresh && !!this.state.orgIntegrationTags[orgId]) { // if tags are already populated do not refetch, unless forceRefresh is true
                    return;
                }

                const actionId = uuid.v4();
                this.setState({ getActionId: actionId }, () => {
                    OrganizationActions.getOrgIntegrationTags(actionId, { orgId: orgId });
                });
            }
        }

        onOrganizationStoreChange(newState) {
            let additionalState = {};
            if (newState.action.id === this.state.getActionId) {
                //TODO: do not set values in case of !!newState.action.error. potential referencing properties of undefined newState.assignmentData
                additionalState = { ...additionalState, getActionId: null };

                if (!!newState.action.error) {
                    additionalState = { ...additionalState, fatalError: newState.action.error };
                }
            }

            this.setState({
                orgIntegrationTags: OrganizationStore.getState().orgIntegrationTags,
                ...additionalState
            });
        }

        onChannelStoreChange(newState) {
            this.getOrgIntegrationTags(this.props.orgId);
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} allowStackTrace={true} />;
            }

            if (!this.state.orgIntegrationTags[this.props.orgId] && !this.props.renderBeforeLodingTags) {
                return (
                    <div className="assignment-instructor">
                        <LoadingMainContent />
                    </div>
                );
            }

            return (
                <WrappedComponent
                    {...this.props}
                    orgIntegrationTags={this.state.orgIntegrationTags[this.props.orgId]}
                />
            );
        }
    }

    WithOrganizationIntegrationTags.propTypes = propTypes;
    WithOrganizationIntegrationTags.defaultProps = defaultProps;
    WithOrganizationIntegrationTags.displayName = `WithOrganizationIntegrationTags(${ReactUtil.getComponentDisplayName(WrappedComponent)})`;
    return WithOrganizationIntegrationTags;
}